import { supplyAgreementTemplateAPI } from "@/views/ContractorAgreementList/services/templateApi";

export const getSupplyAgreementTemplates = async () => {
  try {
    const res = await supplyAgreementTemplateAPI.getList();
    return res?.data;
  } catch (e) {}
};

export const saveSupplyAgreementTemplate = async (formData) => {
  try {
    const res = await supplyAgreementTemplateAPI.save(formData);
    return res;
  } catch (e) {}
};

export const deleteSupplyAgreementTemplate = async (supply_agreement_template_id) => {
  try {
    const res = await supplyAgreementTemplateAPI.delete(supply_agreement_template_id);
    return res;
  } catch (e) {}
};

export const supplyAgreementTemplateColumns = [
  {
    name: "supply_agreement_template_id",
    field: "supply_agreement_template_id",
    label: "ID",
    align: "center",
    sortable: true,
    style: "width: 80px",
  },
  {
    name: "provider_name",
    field: "provider_name",
    label: "Поставщик",
    align: "left",
    sortable: true,
    style: "min-width: 200px",
  },
  {
    name: "template_name",
    field: "template_name",
    label: "Название шаблона",
    align: "left",
    sortable: true,
    style: "min-width: 200px",
  },
  {
    name: "payment_order_name",
    field: "payment_order_name",
    label: "Порядок оплат",
    align: "left",
    sortable: true,
    style: "min-width: 180px",
  },
  {
    name: "file_name",
    field: "file_name",
    label: "Файл",
    align: "left",
    sortable: true,
    style: "min-width: 150px",
  },
  {
    name: "is_active",
    field: "is_active",
    label: "Активен",
    align: "center",
    sortable: true,
    style: "width: 100px",
  },
  {
    name: "created_at",
    field: "created_at",
    label: "Дата создания",
    align: "center",
    sortable: true,
    style: "width: 150px",
  },
  {
    name: "actions",
    field: "actions",
    label: "Действия",
    align: "center",
    style: "width: 120px",
  },
];
